import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { lengthValidation120, required } from '../Forms/utils';

import { REACT_SELECT_INPUT, STYLED_TEXT } from '../Forms/fieldTypes';

const AssignAgentFormComponent = (props) => {
  const { serviceUsersOptions, onLoad, onSubmit, initialValues, form } = props;

  const formData = [
    {
      keyName: 'workerSid',
      label: 'Twilio Worker SID',
      fieldType: STYLED_TEXT,
      validate: [required],
      disabled: true,
    },
    {
      keyName: 'person',
      label: 'Person',
      fieldType: REACT_SELECT_INPUT,
      options: serviceUsersOptions,
      validate: [required],
    },
    {
      keyName: 'name',
      label: 'Call Center Agent Name',
      fieldType: STYLED_TEXT,
      validate: [lengthValidation120],
    },
  ];
  return (
    <>
      <GenericFormContainer
        form={form}
        formData={formData}
        initialValues={initialValues}
        onLoad={onLoad}
        onSubmit={onSubmit}
        title="Assign Agent"
        submitText="Save"
        isFullWidthForm
        backButton={false}
        enableReinitialize
      />
      <Box mb="13rem" />
    </>
  );
};

AssignAgentFormComponent.defaultProps = {
  onLoad: () => {},
};

AssignAgentFormComponent.propTypes = {
  serviceUsersOptions: PropTypes.instanceOf(Array).isRequired,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onLoad: PropTypes.func,
};

export default AssignAgentFormComponent;
